module.exports = __webpack_public_path__ + "img/writer-travel-2.fc751894.png";